var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.832 12.152.004.017a7.879 7.879 0 0 0 4.448 5.546L12 19.86v-2.526h2.667a6.667 6.667 0 0 0 6.666-6.666V9.333a6.667 6.667 0 0 0-6.666-6.666H9.333a6.667 6.667 0 0 0-6.666 6.666v1.334c0 .507.056.998.161 1.467l.004.018ZM14.667 24 6.18 20.143a10.545 10.545 0 0 1-5.955-7.425A9.365 9.365 0 0 1 0 10.667V9.333A9.333 9.333 0 0 1 9.333 0h5.334A9.333 9.333 0 0 1 24 9.333v1.334A9.333 9.333 0 0 1 14.667 20v4Z",
    fill: "#333"
  })));
};
export default SvgReply;